'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validFilterChangeTypeInvariant = undefined;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _filterTypes = require('../constants/filterTypes');

var filterTypes = _interopRequireWildcard(_filterTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validFilterChangeTypeInvariant = exports.validFilterChangeTypeInvariant = function validFilterChangeTypeInvariant(filterType) {
  (0, _invariant2.default)(Object.keys(filterTypes).includes(filterType), 'An invalid filter type was encountered. A valid filter type is required to build an FilterChangeInfo record.');
};